import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CommentsDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"comments_disabled"}/>
}
